/* eslint-disable max-len */

// v3 components
import Button from '@mui/material/Button';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form, { FormMessage } from '/@/components/form';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { resetPassword, setPreferences } from '/@/store/session/actions';
import { getSessionCountry, getSessionLanguage } from '/@/store/session/selectors';
import { validateEmail } from '/@/utils';
import Input from '/@/v3/components/forms/input';
import Label from '/@/v3/components/forms/label';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

@connect(
    (state) => ({
        country: getSessionCountry(state),
        language: getSessionLanguage(state),
    }),
    (dispatch) => bindActionCreators({ resetPassword, setPreferences }, dispatch)
)
export default class PasswordResetRequest extends Form {
    static contextTypes = {
        history: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            success: false,
            loading: false,
            error: undefined,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    fields = {
        email: { initial: '' },
    };

    validation = {
        email: (values) => {
            const result = validateEmail(values.email);
            return result === true || result;
        },
    };

    async handleSubmit() {
        this.setState({ loading: true, success: false, error: undefined });

        try {
            await this.props.resetPassword(this.state.values);
            this.setState({ loading: false, success: true });
        } catch (error) {
            this.setState({ loading: false, error: error.message });
        }
    }

    renderForm() {
        return (
            <Fragment>
                <div className={styles.header}>
                    <span id={styles.icon} onClick={this.props.onClick} className='material-icons'>
                        arrow_back
                    </span>
                    <div className={classNames(styles.logo, styles[`theme-${settings.app.theme}`])} />
                </div>
                <div className={styles.formContainer}>
                    <Title color='primary' bolder theme={settings.app.theme} className={styles.title}>
                        {_('Recuperar contraseña')}
                    </Title>

                    <div>
                        <Label text={_('Email')} size='sm'>
                            <Input
                                type='email'
                                color={settings.app.theme}
                                placeholder={_('Escribí tu email')}
                                {...this.getFieldProps('email')}
                            />
                        </Label>
                        <FormMessage style='error'>{this.state.error}</FormMessage>
                    </div>
                    <div className={styles.descriptionContainer}>
                        <Title color='light' size='md' className={styles.description}>
                            {`${_(
                                'Por motivos de seguridad, el sistema no indica si el email que has introducido pertenece a una cuenta de '
                            )} ${settings.app.name}.`}
                        </Title>
                        <Title color='light' size='md' className={styles.description}>
                            {`${_('Si no recibes un correo electrónico:')}`}
                        </Title>
                        <ol className={styles.numberedList}>
                            <li>
                                <Title color='light' size='md' className={styles.description}>
                                    {`${_('Espera unos minutos.')}`}
                                </Title>
                            </li>
                            <li>
                                <Title color='light' size='md' className={styles.description}>
                                    {`${_('Asegúrate de estar utilizando el correo electrónico correcto.')}`}
                                </Title>
                            </li>
                            <li>
                                <Title color='light' size='md' className={styles.description}>
                                    {`${_(
                                        'Revisa la carpeta de spam, si probaste todo y el problema persiste, contáctanos en '
                                    )}`}
                                    <a
                                        className={styles[`theme-${settings.app.theme}`]}
                                        href='mailto:info@expertobayer.com'
                                    >
                                        {'info@expertobayer.com'}
                                    </a>
                                </Title>
                            </li>
                        </ol>
                    </div>
                    <Button
                        variant='contained'
                        disabled={this.state.loading || !this.validate()}
                        onClick={this.handleSubmit}
                        fullWidth
                    >
                        {this.state.loading ? _('Enviando...') : _('Enviar')}
                    </Button>
                </div>
            </Fragment>
        );
    }

    renderSuccess() {
        return (
            <Fragment>
                <div className={styles.successHeader}>
                    <div className={classNames(styles.logo, styles[`theme-${settings.app.theme}`])} />
                </div>

                <div className={classNames(styles.formContainer, styles.successContainer)}>
                    <div>
                        <Title color='primary' bolder theme={settings.app.theme} className={styles.title}>
                            {_('E-mail enviado!')}
                        </Title>
                        <div className={styles.descriptionContainer}>
                            <Title color='light' size='md' className={styles.confirmText}>
                                {_(
                                    'Revisá tu buzón de entrada y seguí las instrucciones para recuperar tu contraseña.'
                                )}
                            </Title>
                        </div>
                    </div>

                    <Button variant='contained' onClick={this.props.onClick}>
                        {_('Volver')}
                    </Button>
                </div>
            </Fragment>
        );
    }

    render() {
        return <div className={styles.root}>{this.state.success ? this.renderSuccess() : this.renderForm()}</div>;
    }
}
